import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./SharedWithList.scss";
import { ShareWithIconSvg } from "SvgComponents";
import { getSettingValue } from "modules/PermissionModule";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { colors } from "Constants";
import { RadioButton } from "@toddle-edu/ds-web";
import classNames from "classnames";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { onEnterOrSpaceKeyDown } from "Utils";

const hideHelper = {
  everyone: {
    text: "shared_with_sidebar_hidden_from_parents",
    key: "isPrivate",
    id: "everyone",
    label: "students_n_families",
  },
  parent: {
    id: "parent",
    text: "shared_with_sidebar_hidden_from_parents",
    key: "isPrivate",
    label: "only_families",
  },
  student: {
    id: "student",
    text: "shared_with_sidebar_hidden_from_students",
    key: "isHiddenFromStudents",
    label: "shared_with_sidebar_only_students",
  },
  private: {
    id: "private",
    text: "shared_with_sidebar_hidden_from_everyone",
    key: "isHiddenFromStudents",
    label: "private",
  },
};

class SharedWithList extends PureComponent {
  getDerivedData = type => {
    const { isPrivate, isHiddenFromStudents } = this.props.postVisibilityStatus;
    const {
      courseId,
      academicYearId,
      organizationId,
      t,
      userId,
      userEntityType,
    } = this.props;

    const isShowStudentsAllPosts = getSettingValue({
      name: "EnableViewEachOtherPostByStudents",
      courseId,
      organizationId,
      userId,
      userEntityType,
    });

    const courseDetails = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters: {
        academicYearId,
      },
    });

    const courseTitle = _.get(courseDetails, "title", "");

    let description = "";
    let isChecked = false;

    if (type == "everyone") {
      isChecked = !isPrivate && !isHiddenFromStudents;
      if (isShowStudentsAllPosts) {
        description = t("journal:shared_with_students_class_families", {
          courseTitle,
        });
      } else {
        description = t("shared_with_sidebar_des_students_families");
      }
    } else if (type == "student") {
      isChecked = (isPrivate || isHiddenFromStudents) && !isHiddenFromStudents;
      if (isShowStudentsAllPosts) {
        description = t("shared_with_sidebar_des_students_of_class", {
          courseTitle,
        });
      } else {
        description = t("shared_with_sidebar_des_tagged_students");
      }
    } else if (type == "parent") {
      isChecked = (isPrivate || isHiddenFromStudents) && !isPrivate;
      if (isShowStudentsAllPosts) {
        description = t(
          `shared_with_sidebar_des_visible_only_to_family_students`
        );
      } else {
        description = t(
          "shared_with_sidebar_des_visible_only_to_family_students"
        );
      }
    } else if (type == "private") {
      isChecked = isPrivate && isHiddenFromStudents;
      if (isShowStudentsAllPosts) {
        description = t("shared_with_sidebar_des_visible_only_to_teachers");
      } else {
        description = t("shared_with_sidebar_des_visible_only_to_teachers");
      }
    }

    return { isChecked, description };
  };

  onPressItem = type => {
    let param = {};
    if (type == "everyone") {
      param = { isHiddenFromStudents: false, isPrivate: false };
    } else if (type == "student") {
      param = { isHiddenFromStudents: false, isPrivate: true };
    } else if (type == "parent") {
      param = { isHiddenFromStudents: true, isPrivate: false };
    } else if (type == "private") {
      param = { isHiddenFromStudents: true, isPrivate: true };
    }

    this.props.updatePostVisibility?.(param);
  };

  renderElement = ({ item, t }) => {
    const {
      showNewDesign = false,
      itemContainerStyle,
      showNewDesignV2,
    } = this.props;
    const { isChecked: checked, description } = this.getDerivedData(item.id);
    const itemContainerClass = classNames(
      {
        [classes.itemContainer]: true,
      },
      {
        [classes.noBorderBottomContainer]:
          item.id === "private" || showNewDesign,
      },
      {
        [classes.focusOutline]: showNewDesignV2,
      }
    );

    const headingClass = classNames({
      [classes.photoHeading]: true && !showNewDesignV2,
      ["text-label-2"]: showNewDesign,
      [classes.photoHeadingV2]: showNewDesignV2,
    });

    const subTextClass = classNames({
      [classes.subText]: true,
      ["text-body-1"]: showNewDesign,
      [classes.focusOutline]: showNewDesignV2,
    });

    const onHandleKeyDownPressItem = e => {
      onEnterOrSpaceKeyDown(e, () => this.onPressItem(item.id));
    };
    return (
      <div
        data-test-id={`journal-postcreation-sharewith-option-${item.id}`}
        onClick={() => this.onPressItem(item.id)}
      >
        <div
          className={itemContainerClass}
          style={itemContainerStyle}
          tabIndex={0}
          onKeyDown={onHandleKeyDownPressItem}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              ...(showNewDesignV2 && { alignItems: "center" }),
            }}
          >
            <div
              className={classes.iconContainer}
              style={{
                ...(showNewDesignV2
                  ? {
                      backgroundColor: colors.surfaceSubtle,
                      height: "44px",
                      width: "44px",
                    }
                  : {}),
              }}
            >
              <ShareWithIconSvg
                height={showNewDesignV2 ? 20 : 24}
                width={showNewDesignV2 ? 20 : 24}
                type={item.id}
                size={showNewDesignV2 ? "xx-small" : "x-small"}
              />
            </div>
            <div className={classes.nameContainer}>
              <div className={headingClass}>{_.capitalize(t(item.label))}</div>
              <div
                className={subTextClass}
                style={{ ...(showNewDesignV2 ? { marginTop: "0px" } : {}) }}
              >
                {description}
              </div>
            </div>
          </div>
          <div className={classes.svgContainer}>
            <RadioButton checked={checked} tabIndex={-1} />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div className={classes.container}>
        {this.renderElement({ item: hideHelper["everyone"], t })}
        {this.renderElement({ item: hideHelper["parent"], t })}
        {this.renderElement({ item: hideHelper["student"], t })}
        {this.renderElement({ item: hideHelper["private"], t })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  const organizationId = userInfo.org_id;
  const courseId = state.teacher.selected_class.selected_course;
  const academicYearId = getSelectedAcademicYearId(state);
  return {
    courseId,
    organizationId,
    userId: userInfo.id,
    userEntityType: userInfo.userEntityType,
    postDetails: state.post.postDetails,
    academicYearId,
  };
};

export default compose(
  I18nHOC({ resource: "journal" }),
  connect(mapStateToProps, null)
)(SharedWithList);
